import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import { EmendaFederalService } from "../../services/EmendaFederalService";
import { ExercicioService } from "../../services/ExercicioService";

export default {
    name: "GerenciarEmendasFederais",
    components: {
        Breadcrumb,
        StandardPagination
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciar EP. Emenda Federal',
                disabled: true
            }
        ],
        baseHeaders: [
            { text: '', align: 'center', value: 'data-table-select', sortable: false, width: '50px' },
            { text: 'Ano', align: 'center', value: 'ano', width: '100px' },
            { text: 'Parlamentar', align: 'center', value: 'parlamentar', width: '150px' },
            { text: 'Gerência', align: 'center', value: 'gerencia', width: '120px' },
            { text: 'Nº Convênio', align: 'center', value: 'numero_convenio', width: '120px' },
            { text: 'Nº Emenda', align: 'center', value: 'numero_emenda', width: '120px' },
            { text: 'Tipo de Emenda', align: 'center', value: 'tipo_emenda', width: '150px' },
            { text: 'Nº Proposta', align: 'center', value: 'numero_proposta', width: '120px' },
            { text: 'Unidade', align: 'center', value: 'unidade', width: '150px' },
            { text: 'Cidade(s)', align: 'center', value: 'cidades', width: '200px' },
            { text: 'Valor Emenda', align: 'center', value: 'valor_emenda', width: '150px' },
            { text: 'Valor Total Previsto', align: 'center', value: 'valor_total_previsto', width: '170px' },
        ],
        filters: {
            exercicioFilter: [],
            parlamentarFilter: null,
            gerenciaFilter: null,
            descricaoFilter: '',
            numeroConvenioFilter: '',
            numeroEmendaFilter: '',
            tipoEmendaFilter: null,
            numeroPropostaFilter: '',
            unidadeFilter: null,
            cobFilter: '',
            modalidadeFilter: null,
            cidadesFilter: '',
            valorTotalDeFilter: '',
            valorTotalAteFilter: '',
        },
        items: [],
        itemSelected: [],
        showFilters: true,
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        loading: false,
        filterTimeout: null,
        // Opções para os filtros
        exerciciosOptions: [],
        parlamentaresOptions: [],
        gerenciasOptions: [],
        tiposEmendaOptions: [],
        unidadesOptions: [],
        modalidadesOptions: [],
        // Search inputs para autocomplete
        parlamentarSearch: '',
        unidadeSearch: '',
        // Timeouts para autocomplete
        parlamentarSearchTimeout: null,
        unidadeSearchTimeout: null,
        windowWidth: window.innerWidth,
    }),
    computed: {
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        },
        computedHeaders() {
            const isSmallScreen = this.windowWidth < 1200;
            return this.baseHeaders.map(header => {
                if (header.value === 'valor_total_previsto') {
                    return {
                        ...header,
                        text: isSmallScreen ? 'Valor Total' : 'Valor Total Previsto'
                    };
                }
                return header;
            });
        }
    },
    created() {
        this.listarEmendasFederaisPaginado();
        this.carregarOpcoesFiltros();
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarEmendasFederaisPaginado();
        }
    },
    methods: {
        async listarEmendasFederaisPaginado() {
            try {
                this.loading = true;
                const filter = this.prepareFormFilter();

                const response = await EmendaFederalService.index(filter);

                if (typeof response !== 'string' && response && response.data) {
                    this.items = response.data.data || [];
                    this.totalItems = response.data.total || 0;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter as emendas federais.');
                    this.items = [];
                    this.totalItems = 0;
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar as emendas federais:', error);
                this.items = [];
                this.totalItems = 0;
            } finally {
                this.loading = false;
            }
        },
        async carregarOpcoesFiltros() {
            try {
                // Carregar exercícios
                const exerciciosResponse = await ExercicioService.select();
                if (exerciciosResponse && exerciciosResponse.data) {
                    this.exerciciosOptions = exerciciosResponse.data.map(exercicio => ({
                        text: String(exercicio.ano || exercicio.nome || exercicio.id),
                        value: exercicio.ano || exercicio.id
                    }));
                }

                // Carregar gerências
                const gerenciasResponse = await EmendaFederalService.getGerenciasOptions();
                if (gerenciasResponse && gerenciasResponse.data) {
                    this.gerenciasOptions = gerenciasResponse.data.map(gerencia => ({
                        text: gerencia,
                        value: gerencia
                    }));
                }

                // Carregar tipos de emenda
                const tiposEmendaResponse = await EmendaFederalService.getTiposEmendaOptions();
                if (tiposEmendaResponse && tiposEmendaResponse.data) {
                    this.tiposEmendaOptions = tiposEmendaResponse.data.map(tipo => ({
                        text: tipo,
                        value: tipo
                    }));
                }

                // Carregar modalidades
                const modalidadesResponse = await EmendaFederalService.getModalidadesOptions();
                if (modalidadesResponse && modalidadesResponse.data) {
                    this.modalidadesOptions = modalidadesResponse.data.map(modalidade => ({
                        text: modalidade,
                        value: modalidade
                    }));
                }

                // Carregar opções iniciais de parlamentares
                await this.buscarParlamentaresOptions('');

                // Carregar opções iniciais de unidades
                await this.buscarUnidadesOptions('');
            } catch (error) {
                console.error('Ocorreu um erro ao carregar as opções dos filtros:', error);
            }
        },
        async buscarParlamentaresOptions(search = '') {
            try {
                const response = await EmendaFederalService.autocomplete('parlamentar', search);
                if (response && response.data) {
                    this.parlamentaresOptions = response.data.map(parlamentar => ({
                        text: parlamentar,
                        value: parlamentar
                    }));
                }
            } catch (error) {
                console.error('Erro ao buscar parlamentares:', error);
            }
        },
        async buscarUnidadesOptions(search = '') {
            try {
                const response = await EmendaFederalService.getUnidadesOptions(search);
                if (response && response.data) {
                    this.unidadesOptions = response.data.map(unidade => ({
                        text: unidade,
                        value: unidade
                    }));
                }
            } catch (error) {
                console.error('Erro ao buscar unidades:', error);
            }
        },
        handleParlamentarSearch() {
            if (this.parlamentarSearchTimeout) {
                clearTimeout(this.parlamentarSearchTimeout);
            }
            this.parlamentarSearchTimeout = setTimeout(() => {
                this.buscarParlamentaresOptions(this.parlamentarSearch || '');
            }, 300);
        },
        handleUnidadeSearch() {
            if (this.unidadeSearchTimeout) {
                clearTimeout(this.unidadeSearchTimeout);
            }
            this.unidadeSearchTimeout = setTimeout(() => {
                this.buscarUnidadesOptions(this.unidadeSearch || '');
            }, 300);
        },
        prepareFormFilter() {
            const filter = new FormData();
            
            if (this.filters.exercicioFilter && this.filters.exercicioFilter.length > 0) {
                this.filters.exercicioFilter.forEach(exercicio => {
                    filter.append("exercicio[]", exercicio);
                });
            }
            
            if (this.filters.parlamentarFilter) {
                filter.append("parlamentar", this.filters.parlamentarFilter);
            }
            
            if (this.filters.gerenciaFilter) {
                filter.append("gerencia", this.filters.gerenciaFilter);
            }
            
            if (this.filters.descricaoFilter) {
                filter.append("descricao", this.filters.descricaoFilter);
            }
            
            if (this.filters.numeroConvenioFilter) {
                filter.append("numero_convenio", this.filters.numeroConvenioFilter);
            }
            
            if (this.filters.numeroEmendaFilter) {
                filter.append("numero_emenda", this.filters.numeroEmendaFilter);
            }
            
            if (this.filters.tipoEmendaFilter) {
                filter.append("tipo_emenda", this.filters.tipoEmendaFilter);
            }
            
            if (this.filters.numeroPropostaFilter) {
                filter.append("numero_proposta", this.filters.numeroPropostaFilter);
            }
            
            if (this.filters.unidadeFilter) {
                filter.append("unidade", this.filters.unidadeFilter);
            }
            
            if (this.filters.cobFilter) {
                filter.append("cob", this.filters.cobFilter);
            }
            
            if (this.filters.modalidadeFilter) {
                filter.append("modalidade", this.filters.modalidadeFilter);
            }
            
            if (this.filters.cidadesFilter) {
                filter.append("cidades", this.filters.cidadesFilter);
            }
            
            if (this.filters.valorTotalDeFilter) {
                const valor = this.parseValorMonetario(this.filters.valorTotalDeFilter);
                if (valor !== null) {
                    filter.append("valor_total_previsto_de", valor);
                }
            }
            
            if (this.filters.valorTotalAteFilter) {
                const valor = this.parseValorMonetario(this.filters.valorTotalAteFilter);
                if (valor !== null) {
                    filter.append("valor_total_previsto_ate", valor);
                }
            }
            
            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);
            
            return filter;
        },
        
        handlePageChanged(newPage) {
            this.page = newPage;
        },
        
        handleItemsPerPageChanged(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarEmendasFederaisPaginado();
        },
        
        truncateText(text, maxLength) {
            if (!text || text.length <= maxLength) {
                return text || '-';
            }
            return text.substring(0, maxLength) + '...';
        },

        formatCurrency(value) {
            if (!value && value !== 0) {
                return '-';
            }
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },

        formatCidades(cidades) {
            if (!cidades) return '-';
            if (typeof cidades === 'string') {
                return cidades;
            }
            if (Array.isArray(cidades)) {
                return cidades.join(', ');
            }
            return String(cidades);
        },

        // Formatação monetária
        parseValorMonetario(valor) {
            if (!valor || valor === '') return null;
            const cleaned = String(valor).replace(/[^\d]/g, '');
            if (cleaned === '') return null;
            const parsed = parseFloat(cleaned);
            return isNaN(parsed) ? null : parsed;
        },

        handleValorInput(field, value) {
            const cleaned = String(value).replace(/[^\d]/g, '');
            this.filters[field] = cleaned;
        },

        formatValor(field) {
            if (!this.filters[field] || this.filters[field] === '') {
                this.filters[field] = '';
                return;
            }
            const valor = parseFloat(this.filters[field]);
            if (!isNaN(valor)) {
                this.filters[field] = String(valor);
            } else {
                this.filters[field] = '';
            }
        },

        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        
        clearFilters() {
            this.filters = {
                exercicioFilter: [],
                parlamentarFilter: null,
                gerenciaFilter: null,
                descricaoFilter: '',
                numeroConvenioFilter: '',
                numeroEmendaFilter: '',
                tipoEmendaFilter: null,
                numeroPropostaFilter: '',
                unidadeFilter: null,
                cobFilter: '',
                modalidadeFilter: null,
                cidadesFilter: '',
                valorTotalDeFilter: '',
                valorTotalAteFilter: '',
            };
            this.parlamentarSearch = '';
            this.unidadeSearch = '';
            this.page = 1;
            this.listarEmendasFederaisPaginado();
        },
        
        handleFilterChange() {
            // Debounce para evitar muitas chamadas à API
            if (this.filterTimeout) {
                clearTimeout(this.filterTimeout);
            }
            
            this.filterTimeout = setTimeout(() => {
                this.page = 1;
                this.listarEmendasFederaisPaginado();
            }, 300);
        },
        
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },

        getRowClass() {
            return 'row-standard';
        },

        handleResize() {
            this.windowWidth = window.innerWidth;
        }
    }
};

